import React from 'react';
import {useNavigate} from "react-router-dom";
import {IconBox, Type as T} from "@infobis/ui-styles-utils";
import cn from "classnames"

import FlexLine from "@elements/flexLine/FlexLine";

import {Align} from "@baseTypes/baseType";

import st from "./monitoringBackLink.module.scss"


const MonitoringBackLink = (props: any) => {
  
  let {
    path,
    title
  } = props
  
  const navigation = useNavigate()
  
  return (
    <FlexLine align={Align.SpaceBetween} className={st.back}>
      <div
        className={cn(st.back_link)}
        onClick={()=>navigation(path)}>
        <IconBox
          icon={T.IconName.ArrowRight}
        />
      </div>
      <div className={cn(st.back_title)}>
        {title}
      </div>
      <div className={cn(st.back_edit)}>
        <IconBox
          icon={T.IconName.Edit}
        />
      </div>
    </FlexLine>
  )
}
export default MonitoringBackLink;